<template>
  <div>
    <register-successful v-show="success" />

    <div class="login-form" v-show="!success">
      <p class="create-account-title">Create your account below to get started with Cast</p>

      <form @submit.prevent="onSubmit">
        <div class="input-form">
          <div class="email-input-group"> 
            <p class="input-label">Email</p>
            <input class="input" v-model="form.email" required />
            <p class="invalid-label" v-show="hasInvalidEmail"><img src="@/assets/error.png" />Email invalid or is already registered</p>
          </div>

          <div class="password-input-group">
            <p class="input-label">Create password</p>
            <input class="input" v-model="form.password" type="password" required />
            <p class="invalid-label" v-show="hasInvalidPassword"><img src="@/assets/error.png" />{{ invalidPasswordLabel }}</p>
          </div>

          <div class="password-input-group">
            <p class="input-label">Confirm password</p>
            <input class="input" v-model="form.confirmPassword" type="password" required />
            <p class="invalid-label" v-show="hasInvalidPassword"><img src="@/assets/error.png" />{{ invalidPasswordLabel }}</p>
          </div>
        </div>

        <b-button class="form-button" type="submit" variant="primary" >Create account</b-button>

        <div align="center">
          <back-button :backButtonText="backButtonText" @go-back="back" />
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import BackButton from './BackButton.vue'
import RegisterSuccessful from './RegisterSuccessful.vue'

export default {
  components: {
    RegisterSuccessful,
    BackButton
  },
  data(){
    return {
      form: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      hasInvalidEmail: false,
      hasInvalidPassword: false,
      success: false,
      invalidPasswordLabel: '',
      backButtonText: 'Back to login'
    }
  },
  methods: {
    async onSubmit() {
      if (this.form.password != this.form.confirmPassword){
        this.hasInvalidPassword = true;
        this.invalidPasswordLabel = 'Confirm password did not match'
        return;
      }
      
      if (this.form.password.length < 8) {
        this.hasInvalidPassword = true;
        this.invalidPasswordLabel = 'Password must have at least 8 characters'
        return;
      }

      var response_json = await this.register()
      if (response_json.status === "fail") {
        this.hasInvalidEmail = true
        this.hasInvalidPassword = false
      } else {
        this.hasInvalidEmail = false
        this.hasInvalidPassword = false
        this.form.email = ''
        this.form.password = ''
        this.success = true;
      }
    },
    async register() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      var urlencoded = new URLSearchParams();
      urlencoded.append("grant_type", "register");
      urlencoded.append("client_id", "CAST");
      urlencoded.append("username", this.form.email);
      urlencoded.append("password", this.form.password);
      urlencoded.append("device_id", "CAST");

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      return await fetch(`https://oauth${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : '-stage'}.fanscore.com/oauth/token`, requestOptions)
        .then(response => response.json())
        .then(data => {
          return data
        })
        .catch(error => {
          console.log('error', error)
        });
    },
    back() {
      this.form = {
        email: '',
        password: '',
        confirmPassword: ''
      },
      this.hasInvalidEmail = false
      this.hasInvalidPassword = false
      this.success = false
      this.$emit('back-to-login')
    }
  }
}
</script>

<style>
.create-account-title {
  text-align: left;
}
</style>